import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import Button from '@material-ui/core/Button';
// eslint-disable-next-line import/no-duplicates
import AccountIcon from '@material-ui/icons/AccountCircle';
// eslint-disable-next-line import/no-duplicates
import ExitIcon from '@material-ui/icons/AccountCircle';
import { getIsGlobalUser, getUser } from '../../features/loginSystem/selectors';
import { getIsDataDirty } from '../../features/app/selectors';
import { logoutRoute, marketSettingsRoute } from '../../routes';
import useAlert from '../../features/alertSystem/hooks/useAlert';
import { toJS } from '../../utils/immutableUtils';
import { ExitToApp, Public, Settings } from '@material-ui/icons';

const UserMenu = () => {
  const history = useHistory();
  const user = toJS(useSelector(getUser));
  const isDataDirty = useSelector(getIsDataDirty);
  const [openAlert, closeAlert] = useAlert();
  const [anchorEl, setAnchorEl] = useState(null);
  const isGlobalUser = useSelector(getIsGlobalUser);

  const handleLogout = () => {
    if (isDataDirty) {
      openAlert({
        title: <FormattedMessage id="appBar.confirmLogoutTitle" />,
        content: <FormattedMessage id="appBar.confirmLeaveMessage" />,
        actions: {
          right: (
            <>
              <Button key="stay" onClick={closeAlert} color="primary">
                <FormattedMessage id="appBar.confirmStayOnPageButtonText" />
              </Button>
              <Button
                key="leave"
                onClick={() => {
                  closeAlert();
                  history.replace(logoutRoute());
                }}
                color="secondary"
              >
                <FormattedMessage id="appBar.confirmLogoutButtomText" />
              </Button>
            </>
          )
        }
      });
    } else {
      history.replace(logoutRoute());
    }
  };
  const handleMarketSettings = () => {
    handleClose();
    history.push(marketSettingsRoute());
  };
  const getMenuOptions = () => {
    return [
      // {
      //   key: 'Settings',
      //   icon: <Settings />,
      //   primary: <FormattedMessage id="appBar.mySetting" />,
      //   // onClick: e => this.handleNavigation('mySettings')
      //   permission: true
      // },
      {
        key: 'Market_Settings',
        icon: <Public />,
        primary: <FormattedMessage id="appBar.marketSetting" />,
        onClick: handleMarketSettings,
        permission: !isGlobalUser
      },
      {
        key: 'Logout',
        icon: <ExitToApp />,
        primary: <FormattedMessage id="appBar.logoutBtn" />,
        onClick: handleLogout,
        permission: true
      }
    ];
  };

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (onClick = () => {}) => () => {
    setAnchorEl(null);
    onClick();
  };

  return (
    <>
      <IconButton
        aria-owns={anchorEl ? 'menu-appbar' : null}
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <AccountIcon />
      </IconButton>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose()}
      >
        <ListItem button disabled divider>
          <ListItemIcon>
            <AccountIcon />
          </ListItemIcon>
          <ListItemText primary={user && user.username} />
        </ListItem>
        {getMenuOptions().map(option => {
          return option.permission === true ? (
            <ListItem
              button
              key={option.key}
              onClick={handleClose(option.onClick)}
            >
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText
                primary={option.primary}
                secondary={option.secondary}
              />
            </ListItem>
          ) : null;
        })}
      </Menu>
    </>
  );
};

export default UserMenu;
